import React from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  SelectInput,
  DateTimeInput,
  BooleanInput,
  NumberInput,
  required,
  ReferenceInput,
  ReferenceManyField,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  DeleteButton,
} from 'react-admin';

const challengeTypeChoices = [
  { id: 'quit_smoking', name: 'Бросить курить' },
  { id: 'quit_porn', name: 'Бросить порно' },
  { id: 'quit_sugar', name: 'Бросить сахар' },
  { id: 'quit_alcohol', name: 'Бросить алкоголь' },
  { id: 'exercise', name: 'Упражнения' },
  { id: 'meditation', name: 'Медитация' },
  { id: 'reading', name: 'Чтение' },
  { id: 'water_drinking', name: 'Пить воду' },
  { id: 'sleep_schedule', name: 'Режим сна' },
  { id: 'no_social_media', name: 'Без соцсетей' },
  { id: 'custom', name: 'Кастомный' },
];

const challengeStatusChoices = [
  { id: 'active', name: 'Активный' },
  { id: 'paused', name: 'Приостановлен' },
  { id: 'completed', name: 'Завершен' },
  { id: 'failed', name: 'Провален' },
];

const challengeModeChoices = [
  { id: 'personal', name: 'Личный' },
  { id: 'group', name: 'Групповой' },
];

export const ChallengeEdit = () => (
  <Edit>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput source="title" validate={[required()]} label="Название" />
        <TextInput source="description" multiline rows={4} label="Описание" />
        <SelectInput source="type" choices={challengeTypeChoices} validate={[required()]} label="Тип" />
        <SelectInput source="status" choices={challengeStatusChoices} validate={[required()]} label="Статус" />
        <SelectInput source="mode" choices={challengeModeChoices} validate={[required()]} label="Режим" />
        
        <DateTimeInput source="startDate" validate={[required()]} label="Дата начала" />
        <DateTimeInput source="endDate" label="Дата окончания" />
        
        <BooleanInput source="isPublic" label="Публичный" />
        <NumberInput source="maxParticipants" label="Максимум участников" />
      </FormTab>

      <FormTab label="Автор">
        <ReferenceInput source="userId" reference="users" label="Автор">
          <SelectInput optionText="name" />
        </ReferenceInput>
      </FormTab>

      <FormTab label="Статистика">
        <NumberInput source="currentStreak" label="Текущая серия" />
        <NumberInput source="bestStreak" label="Лучшая серия" />
        <NumberInput source="totalDays" label="Всего дней" />
      </FormTab>

      <FormTab label="Стейкинг">
        <BooleanInput source="isStaked" label="Включен стейкинг" />
        <BooleanInput source="stakingCompleted" label="Стейкинг завершен" />
        <TextInput source="stakedAmount" label="Сумма стейка" />
        <TextInput source="stakingTokenAddress" label="Адрес токена" />
        <TextInput source="stakingTransactionHash" label="Хеш транзакции" />
      </FormTab>

      <FormTab label="Участники">
        <ReferenceManyField reference="challengeParticipants" target="challengeId" label="Участники">
          <Datagrid>
            <TextField source="id" label="ID" />
            <TextField source="user.name" label="Пользователь" />
            <TextField source="role" label="Роль" />
            <TextField source="status" label="Статус" />
            <TextField source="currentStreak" label="Серия" />
            <DateField source="joinedAt" label="Присоединился" />
            <EditButton />
            <DeleteButton />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>

      <FormTab label="Обновления">
        <ReferenceManyField reference="challengeUpdates" target="challengeId" label="Обновления">
          <Datagrid>
            <TextField source="id" label="ID" />
            <TextField source="type" label="Тип" />
            <TextField source="content" label="Содержимое" />
            <TextField source="user.name" label="Автор" />
            <DateField source="createdAt" label="Дата" />
            <EditButton />
            <DeleteButton />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
    </TabbedForm>
  </Edit>
);





